module.exports = __webpack_public_path__ + "media/landing-v2/desktop_new_logo-7a4617c4.svg";